import React, { useEffect, useState } from "react";
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Logo from "../assets/images/logo.png";
import { IconBriefcase, IconMenuDeep } from '@tabler/icons-react';
import { Link, useLocation } from 'react-router-dom';
import axios from "axios";

function Header() {
    const location = useLocation();
    const [projeler, setProjeler] = useState([]);

    useEffect(() => {
        const fetchProjects = async () => {
            try {
                const response = await axios.get("https://admin.k12pulse.com/api/proje");
                const data = response.data;
                const projeListesi = Array.isArray(data)
                    ? data
                    : Array.isArray(data?.data)
                        ? data.data
                        : [];
                setProjeler(projeListesi);
            } catch (error) {
                console.error("Proje verisi alınamadı:", error);
            }
        };
        fetchProjects();
    }, []);

    // Proje slugu üzerinden aktifliği kontrol etme
    const isProjectActive = (slug) => {
        return location.pathname.includes(slug);
    };

    return (
        <header>
            <Navbar expand="lg" className="justify-content-between">
                <Container className='d-flex justify-content-between'>
                    <Navbar.Brand href="/">
                        <img src={Logo} alt="logo" className={'header-logo'}/>
                    </Navbar.Brand>
                    <Navbar.Toggle>
                        <span className='navbar-toggle-icon'>
                            <IconMenuDeep size={32} />
                        </span>
                    </Navbar.Toggle>
                    <Navbar.Collapse id="navbarScroll">
                        <Nav className="m-auto gap-1 gap-lg-4">
                            <Nav.Link href="/" className={location.pathname === "/" ? "active" : ""}>Anasayfa</Nav.Link>
                            <Nav.Link href="/hakkimizda" className={location.pathname.includes("hakkimizda") ? "active" : ""}>Hakkımızda</Nav.Link>

                            {/* Projeler dropdown */}
                            <NavDropdown
                                title="Çözümlerimiz"
                                id="navbarScrollingDropdown"
                                className={projeler.some(proje => isProjectActive(proje.slug || proje.title.toLowerCase().replace(/\s+/g, "-"))) ? "active" : ""}
                            >
                                {projeler.map((proje) => {
                                    const slug = proje.slug || proje.title.toLowerCase().replace(/\s+/g, "-");
                                    return (
                                        <NavDropdown.Item
                                            key={slug}  // Benzersiz key olarak 'slug' kullanıyoruz
                                            href={`/cozumlerimiz/${slug}`}
                                            className={isProjectActive(slug) ? "active" : ""}
                                        >
                                            {proje.title}
                                        </NavDropdown.Item>
                                    );
                                })}
                            </NavDropdown>

                            <Nav.Link href="/iletisim" className={location.pathname.includes("iletisim") ? "active" : ""}>İletişim</Nav.Link>
                        </Nav>

                        {/* Kariyer Button */}
                        <Link to="/kariyer">
                            <Button className='d-flex align-items-center mt-1 custom-career-btn'>
                                <IconBriefcase /> Kariyer
                            </Button>
                        </Link>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </header>
    );
}

export default Header;
